import styled from "styled-components/macro"
import { Dispatch, SetStateAction } from "react"

import { ReactComponent as Minus } from "../../assets/smallMinus.svg"
import { ReactComponent as Plus } from "../../assets/smallPlus.svg"
import { ReactComponent as Zoom } from "../../assets/zoom.svg"
import { ReactComponent as RotateLeft } from "../../assets/rotate-left.svg"
import { ReactComponent as RotateRight } from "../../assets/rotate-right.svg"
import { colors } from "../../styles/design.config"
import { canvasZoomRatio } from "../../utils/canvas"

interface ControlBarProps {
  scale: number
  setScale: Dispatch<SetStateAction<number>>
  rotationAngle: number
  setRotationAngle: Dispatch<SetStateAction<number>>
}

export const ControlBar = ({
  setScale,
  scale,
  setRotationAngle,
  rotationAngle,
}: ControlBarProps) => {
  return (
    <ControlBarWrapper>
      <Button
        onClick={() => {
          setRotationAngle((rotationAngle - 90) % 360)
        }}
      >
        <RotateLeft />
      </Button>

      <Button
        onClick={() => {
          setRotationAngle((rotationAngle + 90) % 360)
        }}
      >
        <RotateRight />
      </Button>

      <Button
        onClick={() => {
          setScale(scale * canvasZoomRatio)
        }}
      >
        <ZoomPlus />
      </Button>

      <Button
        onClick={() => {
          setScale(scale / canvasZoomRatio)
        }}
      >
        <ZoomMinus />
      </Button>
    </ControlBarWrapper>
  )
}

const ControlBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.cornflower};
  border: 2px solid ${colors.cornflower};
  height: 4.2rem;
  width: 4.2rem;
  border-radius: 50%;
  margin: 0 0.5rem;
  cursor: pointer;
`

const ZoomPlus = () => {
  return (
    <ZoomWrapper>
      <Zoom />
      <StyledPlus />
    </ZoomWrapper>
  )
}

const ZoomMinus = () => {
  return (
    <ZoomWrapper>
      <Zoom />
      <StyledMinus />
    </ZoomWrapper>
  )
}

const ZoomWrapper = styled.div`
  position: relative;
  right: 0.2rem;
  height: 3.5rem;
  width: 3.5rem;
`

const IconStyle = `
  position: absolute;
  top: 0.2rem;
  right: -0.3rem;
  fill: white;
`
const StyledPlus = styled(Plus)`
  ${IconStyle}
`

const StyledMinus = styled(Minus)`
  ${IconStyle}
`
